import React, { useState } from "react";

export default function WorkingServiceForm(props) {
    return (
        <>
            <div
                id={`${
                    typeof props.id !== "undefined" ? props.id : "responsive-modal"
                }`}
                className="modal fade bs-example-modal-lg"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                style={{ display: "none" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myLargeModalLabel">
                                {props.title ?? ""}
                            </h4>
                            <button
                                type="button"
                                className={`${
                                    typeof props.close !== "undefined" ? props.close : "close"
                                }`}
                                id={`${
                                    typeof props.close !== "undefined" ? props.close : "close"
                                }`}
                                data-dismiss="modal"
                                aria-hidden="true"
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 mb-3" style={{backgroundColor: '#eeeeee'}}>
                                    <h4 className="card-title font-weight-bold pt-2">Person Info</h4>
                                </div>
                                <div className="mb-3 form-group col-md-12">
                                    <label className="form-label">Title</label>
                                    <select className="form-control" name="title" id="title"
                                            value={props.formData.title} onChange={props.onEdit}>
                                        <option value="">Select Title</option>
                                        <option>Mr</option>
                                        <option>Mrs</option>
                                        <option>Mss</option>
                                        <option>Ms</option>
                                        <option>Dr</option>
                                        <option>Capt</option>
                                        <option>Prof</option>
                                        <option>HRH</option>
                                    </select>
                                </div>
                                <div className="mb-3 form-group col-md-6">
                                    <label className="form-label">First Name</label>
                                    <input
                                        name="firstName"
                                        className="form-control"
                                        id="firstName"
                                        value={props.formData.firstName}
                                        onChange={props.onEdit}
                                        placeholder="First Name"
                                    />
                                </div>

                                <div className="mb-3 form-group col-md-6">
                                    <label className="form-label">Middle Name</label>
                                    <input
                                        name="middleName"
                                        className="form-control"
                                        id="middleName"
                                        value={props.formData.middleName}
                                        onChange={props.onEdit}
                                        placeholder="Middle Name"
                                    />
                                </div>

                                <div className="mb-3 form-group col-md-6">
                                    <label className="form-label">Surname</label>
                                    <input
                                        name="surname"
                                        className="form-control"
                                        id="surname"
                                        value={props.formData.surname}
                                        onChange={props.onEdit}
                                        placeholder="Surname"
                                    />
                                </div>
                                <div className="mb-3 form-group col-md-6">
                                    <label className="form-label">Gender</label>
                                    <select className="form-control" name="gender" id="gender"
                                            value={props.formData.gender} onChange={props.onEdit}>
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                </div>
                                <div className="mb-3 form-group col-md-6">
                                    <label className="form-label">Email Address</label>
                                    <input
                                        name="emailAddress"
                                        className="form-control"
                                        id="emailAddress"
                                        value={props.formData.emailAddress}
                                        onChange={props.onEdit}
                                        placeholder="Email Address"
                                    />
                                </div>
                                <div className="mb-3 form-group col-md-6">
                                    <label className="form-label">Phone Number</label>
                                    <input
                                        name="phoneNumber"
                                        className="form-control"
                                        id="phoneNumber"
                                        value={props.formData.phoneNumber}
                                        onChange={props.onEdit}
                                        placeholder="Phone Number"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-default waves-effect"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            {props.IsFormLoading ? (
                                <button type="button" className="btn btn-primary ms-auto">
                  <span>
                    <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                    />{" "}
                      Please wait...
                  </span>
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    onClick={props.onSubmit}
                                    className="btn btn-danger waves-effect waves-light"
                                >
                                    {props.btn ?? "submit"}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
